export default "__VITE_ASSET__df20ae51__"